// /src/data/opensource.js
// Open-source projects showcased on domeniclaurenzi.com
export const projects = [
  {
    name: 'DirCompare',
    description:
      'Compare two directories to determine which is more up-to-date using MD5 hashing, version detection, git analysis, and weighted scoring. Zero dependencies.',
    tech: ['Python 3.10+', 'Zero Dependencies'],
    category: 'Developer Tools',
    github: 'https://github.com/hackingpain/DirCompare',
    status: 'Complete',
  },
  {
    name: 'Trading Bot',
    description:
      'Automated stock trading bot with paper trading, multiple strategies (RSI/MACD, mean reversion, momentum, breakout, pairs trading), Streamlit dashboard, and backtesting.',
    tech: ['Python', 'Streamlit', 'Alpaca API', 'Docker'],
    category: 'AI & Finance',
    github: 'https://github.com/hackingpain/trading-bot',
    status: 'Complete',
  },
  {
    name: 'PixieSwitch',
    description:
      'Batch GUI image converter with animation support, metadata handling, resizing, and quality control. Supports JPEG, PNG, GIF, WebP, BMP, TIFF, ICO, and HEIF.',
    tech: ['Python', 'Pillow', 'imageio'],
    category: 'Media Tools',
    github: 'https://github.com/hackingpain/PixieSwitch',
    status: 'Complete',
  },
  {
    name: 'Social Text Styler',
    description:
      'Generate Unicode-styled text (bold, italic, underline, strikethrough) for social media platforms. Single-file, zero external dependencies.',
    tech: ['Python', 'Tkinter'],
    category: 'Utilities',
    github: 'https://github.com/hackingpain/social-text-styler',
    status: 'Complete',
  },
  {
    name: 'CSVinsights',
    description:
      'GUI tool for CSV file exploration and analysis. Statistics, correlations, data preview, and quick export.',
    tech: ['Python', 'Tkinter', 'Pandas'],
    category: 'Data Tools',
    github: 'https://github.com/hackingpain/CSVinsights',
    status: 'Complete',
  },
  {
    name: 'EraseDrive',
    description:
      'GUI tool for safely wiping non-system disks on Windows. Admin privilege checks, disk listing with details, confirmation prompts, and automatic refresh after wipe.',
    tech: ['PowerShell', 'Windows Forms'],
    category: 'Utilities',
    github: 'https://github.com/hackingpain/EraseDrive',
    status: 'Complete',
  },
  {
    name: 'Rate-Limit-Checker',
    description:
      'Security testing tool that simulates form submissions to check for rate-limiting vulnerabilities. Automates reCAPTCHA solving, Base64-encoded targets, and real-time logging.',
    tech: ['Python', 'Tkinter', '2Captcha API'],
    category: 'Security',
    github: 'https://github.com/hackingpain/Rate-Limit-Checker',
    status: 'Complete',
  },
  {
    name: 'TranscribeX',
    description:
      'Desktop transcription app for MP3/MP4 and other media files. Uses faster-whisper with optional NVIDIA CUDA acceleration, VAD silence trimming, and timestamp support.',
    tech: ['Python', 'PyQt6', 'faster-whisper', 'FFmpeg'],
    category: 'AI & ML',
    github: 'https://github.com/hackingpain/TranscribeX',
    status: 'Complete',
  },
];
